import { Component, OnInit } from '@angular/core';
import { ClassroomService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import { AppGlobals } from '../../shared/app.global';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-worksheet',
  templateUrl: './worksheet.component.html',
  styleUrls: ['./worksheet.component.scss'],
  providers:[ClassroomService,MasterService]
})
export class WorksheetComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
 
  
  cnid:any;
  
  arrftype=[{name:'Url'},{name:'File'}];
  ftype:any;
  fpath:any;
  fnm:any;
  arrstudoc:any=[];
  fileToUpload: File = null;

  fData: FormData = new FormData;
  notetype=[{name:'Homework'},{name:'Activity'},{name:'Information'}];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    sections:any=[];
    classes:any=[];
    arrsubjects:any=[];
    arrschnote:any=[];
    arrschnoteda:any=[];
    arrrepdata:any=[];
    arrcourse:any=[];
    fmodel:any={clid:'0',crid:'0',subid:'0',prid:'0'};

  constructor(private http: HttpClient, private cservice: ClassroomService,private mservice:MasterService,private modalService: NgbModal,private apglobal:AppGlobals) { }

  ngOnInit(): void {
    this.getcourselist();
  }

 
  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            //this.fmodel.clid=resultArray[0].clid;
            this.objsch.clid=resultArray[0].clid;
          //  this.massection();
            this.Bindtable();
           
        },
        error => console.log("Error :: " + error)
        )
  }

 
  // massection() {
  //   this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
  //       .subscribe(
  //       resultArray => {
  //           console.log('getdashcounts', resultArray);
  //           this.sections = resultArray;
  //           this.fmodel.secid=resultArray[0].scid;
  //           this.objsch.secid=resultArray[0].scid;
  //           this.subjects();
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }

  getcourselist() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.arrcourse = resultArray;
          //  this.fmodel.crid=resultArray[0].crid;
            this.objsch.crid=resultArray[0].crid;
            this.masclass(); 

        },
        error => console.log("Error :: " + error)
        )
  }
  
 

    

    
    Bindtable() {
      debugger
      
      
      this.cservice.getcomwksheet(this.fmodel.clid,this.fmodel.crid)
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrschnote = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }


  bindnoteda(cnid) {
    debugger
    
    
    this.cservice.getcomclnoteda(cnid)
        .subscribe(resultArray => {
           console.log('ret-select', resultArray);
            this.arrschnoteda = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    
}

delcomwksheet(cnid) {
  debugger
  if (confirm('Are you sure you want to delete'))
  {
  this.cservice.delcomwksheet(cnid)
      .subscribe(resultArray => {
        // console.log('ret-select', resultArray);
          //this.arrschnoteda = resultArray;
          alert (resultArray.message);
this.Bindtable();
      }, error =>
          alert('error in connection')
      );
    }
}


openlink(url){
  

  window.open(url,'','_blank');
}
SaveDetails() {
    
  console.log('save-model', this.objsch);
  var dbnm='';
  

  this.cservice.savecomclnote(this.objsch)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.Bindtable();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();

}

viewfile(fpath)
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
  var path=this.cservice.callurl.replace("/api/v3","");
   var url=path+fpath;
   console.log("url",url)
   window.open(url,'');

}

    opensubject(content,objdata,cmd) {
      debugger

      console.log(objdata);
      if(cmd=='insert')
      {
        this.objsch={};
       
        
        //console.log('date',this.sservice.getdatetoday().toString())
       // this.objsch.cntype='Homework';
        this.objsch.rid='0';
        this.objsch.fnm='';
       // this.objsch.cncontent='';
       // this.objsch.cndt=this.apglobal.getdatetoday();
       // this.objsch.cnduedt=this.apglobal.getdatetoday();
        this.objsch.clid=this.fmodel.clid;
        this.objsch.fpath="";
      
        this.objsch.crid=this.fmodel.crid;
        this.objsch.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
  debugger
        
        this.objsch=objdata;
        
       // this.objsch.stuid=objdata.stuid;
        this.objsch.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
        
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    openinfo(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
this.bindnoteda(nfid);
  this.cnid=nfid;
  this.fpath='';
  this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);


  
}

fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.cservice.uploadcomwksheet(this.fileToUpload,this.objsch)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;

this.objsch.fnm="";

this.Bindtable();
}
    
}, error => 
alert('error in connection')

);



}


delnoteda(stuid) {
  if(confirm("Are you sure you wan't to delete?"))
  {
  this.cservice.delnoteda(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          //this.arrstudoc = resultArray;
          alert(resultArray.message);
          this.bindnoteda(this.cnid);
         
      },
      error => console.log("Error :: " + error)
      )
    }
}

}

